import { render } from "./AffixCustomerService.vue?vue&type=template&id=793be0aa&scoped=true"
import script from "./AffixCustomerService.vue?vue&type=script&lang=js"
export * from "./AffixCustomerService.vue?vue&type=script&lang=js"

import "./AffixCustomerService.vue?vue&type=style&index=0&id=793be0aa&lang=scss&scoped=true"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793be0aa"]])

export default __exports__